import { BitkitIconComponent } from '@bitrise/bitkit-v2';
import { Box, BoxProps } from '@chakra-ui/react/box';

interface LinkItemProps extends Omit<BoxProps, 'as'> {
  href?: string;
  icon: BitkitIconComponent;
  isExternal?: boolean;
}

const LinkItem = (props: LinkItemProps) => {
  const { children, href, icon: Icon, isExternal, ...rest } = props;

  const content = (
    <>
      <Icon />
      {children}
    </>
  );

  return (
    <Box
      alignItems="center"
      color="text/primary"
      display="flex"
      gap="12"
      paddingBlock="12"
      paddingInline="24"
      textAlign="start"
      textStyle="body/lg/regular"
      width="100%"
      _active={{ backgroundColor: 'background/active' }}
      _hover={{ backgroundColor: 'background/hover' }}
      asChild
      {...rest}
    >
      {href ? (
        <a href={href} rel={isExternal ? 'noreferrer noopener' : undefined} target={isExternal ? '_blank' : undefined}>
          {content}
        </a>
      ) : (
        <button type="button">{content}</button>
      )}
    </Box>
  );
};

export default LinkItem;
